/**
 * Minimale SSE-lezer voor fetch-responses (EventSource kan geen POST met JSON-body en
 * Authorization-header). Levert per frame `{ event, data }`; stopt bij `event: end`.
 */
export interface SseFrame {
  event: string | null;
  data: string;
}

export function parseSseFrame(raw: string): SseFrame | null {
  let event: string | null = null;
  const data: string[] = [];
  for (const line of raw.split('\n')) {
    if (!line || line.startsWith(':')) continue; // commentaar/keep-alive
    if (line.startsWith('event:')) event = line.slice(6).trim();
    else if (line.startsWith('data:')) data.push(line.slice(5).replace(/^ /, ''));
  }
  if (event === null && data.length === 0) return null;
  return { event, data: data.join('\n') };
}

export async function readSseStream(
  body: ReadableStream<Uint8Array>,
  onFrame: (frame: SseFrame) => void,
): Promise<void> {
  const reader = body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  try {
    for (;;) {
      const { value, done } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true }).replace(/\r\n/g, '\n');
      let idx: number;
      while ((idx = buffer.indexOf('\n\n')) !== -1) {
        const raw = buffer.slice(0, idx);
        buffer = buffer.slice(idx + 2);
        const frame = parseSseFrame(raw);
        if (!frame) continue;
        onFrame(frame);
        if (frame.event === 'end') return;
      }
    }
    const tail = parseSseFrame(buffer);
    if (tail) onFrame(tail);
  } finally {
    try {
      reader.releaseLock();
    } catch {
      /* al vrijgegeven */
    }
  }
}
